import { ModalProps } from "antd/lib/modal/Modal";
import {
    Button,
    Col,
    Input,
    message,
    Modal,
    Row,
    Select,
    Table,
    Spin
} from "antd";
import React, { useState } from "react";
import { useAtomValue } from "jotai";
import { termListAtom } from "../../../../../../service/stores/CommonStore";
import { ResultMessage } from "../../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../../service/service";
import useRequestFn from "../../../../../../utils/useRequestFn";
import {
    copyToCurrent,
    CourseListItem,
    getCourseListProps,
    postFindCourseList
} from "../../../../../../service/score";
import Style from "./index.module.scss";
import Form from "rc-field-form";
import { ColumnProps } from "antd/es/table";
import useSelection from "../../../../../../utils/v2/useSelection";
import Config from "../../../../../../config";
import config from "../../../../../../config";
import Storage from "../../../../../../utils/Storage";

interface Props extends ModalProps {
    onSuccess: () => void;
    courseNo: string;
    courseSeq: string;
}

const Index = ({ courseNo, courseSeq, onSuccess, ...props }: Props) => {
    const batchList = useAtomValue(termListAtom);

    const [saveAction, { loading: saveLoading }] = useRequestFn(copyToCurrent);

    const [getDataAction, { loading: getLoading }] =
        useRequestFn(postFindCourseList);

    const [data, setData] = useState<CourseListItem[]>([]);
    async function onFinish(data: getCourseListProps) {
        try {
            const _data = await getDataAction(data);
            setData(_data);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const columns: ColumnProps<CourseListItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            render: (text, row, index: number) => index + 1,
            align: "center"
        },
        {
            title: "课程信息",
            render: (text, row) => {
                return `${row.coursename} [${row.courseno}-${row.courseseq}]`;
            }
        }
    ];

    const rowSelection = useSelection();

    async function onSave() {
        try {
            const index = data.findIndex(
                item => item.id === rowSelection.selected[0]
            );
            const batchNo = Storage.get("batch") || Config.DefaultBatch;
            const selectItem = data[index];
            await saveAction({
                copy: {
                    courseNo: courseNo,
                    courseSeq: courseSeq,
                    customerCode: config.CustomCode,
                    batchNo
                },
                target: {
                    courseNo: selectItem?.courseno,
                    courseSeq: selectItem?.courseseq,
                    customerCode: selectItem?.customerCode,
                    batchNo: selectItem?.batchNo
                }
            });
            message.success("复制成功");
            onSuccess();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            okButtonProps={{
                loading: [saveLoading, getLoading].some(i => i),
                disabled: rowSelection.selected?.length < 1
            }}
            onOk={onSave}
            width={800}
            title="复制成绩规则">
            <Spin spinning={[saveLoading, getLoading].some(i => i)}>
                <Form onFinish={onFinish} className={Style.row}>
                    <Row gutter={15}>
                        <Col span={6}>
                            <Form.Field name="batchNo">
                                <Select
                                    placeholder="请选择学期"
                                    className={Style.select}>
                                    {batchList.map(item => (
                                        <Select.Option
                                            value={item.batchNo}
                                            key={item.batchNo}>
                                            {item.batchName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Field>
                        </Col>
                        <Col span={12}>
                            <Form.Field name="keyword">
                                <Input
                                    className={Style.input}
                                    placeholder="输入课程关键字或编号"
                                />
                            </Form.Field>
                        </Col>
                        <Button type="primary" htmlType="submit">
                            搜索
                        </Button>
                    </Row>
                </Form>
                <Table
                    className={Style.table}
                    dataSource={data}
                    columns={columns}
                    size="small"
                    rowKey="id"
                    rowSelection={{
                        type: "radio",
                        ...rowSelection
                    }}
                />
            </Spin>
        </Modal>
    );
};
export default Index;
